import { makeActionCreator } from '../../config/store/utils'
import { getAgilePurchaseTradedTopProviders } from '../../services/agilePurchase'

export const GET_AGILE_PURCHASE_TRADED_PROVIDERS = 'GET_AGILE_PURCHASE_TRADED_PROVIDERS'
export const GET_AGILE_PURCHASE_TRADED_PROVIDERS_SUCCESS = 'GET_AGILE_PURCHASE_TRADED_PROVIDERS_SUCCESS'
export const GET_AGILE_PURCHASE_TRADED_PROVIDERS_ERROR = 'GET_AGILE_PURCHASE_TRADED_PROVIDERS_ERROR'

export const onGetAgilePurchaseTradedProviders = makeActionCreator(GET_AGILE_PURCHASE_TRADED_PROVIDERS)
export const onGetAgilePurchaseTradedProvidersSuccess = makeActionCreator(
  GET_AGILE_PURCHASE_TRADED_PROVIDERS_SUCCESS,
  'payload'
)
export const onGetAgilePurchaseTradedProvidersError = makeActionCreator(
  GET_AGILE_PURCHASE_TRADED_PROVIDERS_ERROR,
  'payload'
)

export const onGetAgilePurchaseTradedProvidersThunk =
  ({ year, region }) =>
  async dispatch => {
    dispatch(onGetAgilePurchaseTradedProviders())

    try {
      const response = await getAgilePurchaseTradedTopProviders({ year, region })
      if (response.status !== 200) {
        return dispatch(onGetAgilePurchaseTradedProvidersError(response.errores))
      }

      const enhancedData = response.data.payload.map(datum => ({
        year: datum.anio,
        providerRUT: datum.rut,
        providerName: datum.proveedor,
        orders: datum.cantidad,
        amount: datum.monto,
        amountUSD: datum.montoUSD,
        quotes: datum.totalContizaciones,
        region: datum.region,
        idRegion: datum.idRegion
      }))
      const csv = [
        ['Región', 'Proveedor', 'RUT proveedor', 'Monto total (CLP)', 'Monto total (USD)', 'Nº de órdenes de compra'],
        ...enhancedData.map(datum => [
          datum.region,
          datum.providerName,
          datum.providerRUT,
          datum.amount,
          datum.amountUSD,
          datum.orders
        ])
      ]
      return dispatch(onGetAgilePurchaseTradedProvidersSuccess({ csv, data: enhancedData }))
    } catch (error) {
      return dispatch(
        onGetAgilePurchaseTradedProvidersError({ error: error.message || 'Error al obtener datos', csv: [], data: [] })
      )
    }
  }
